const VIEW = 'avaus'
const REVIEW = 'tarkistettu'
const CLEAR = 'tyhjennetty'
const SEARCH = 'haku'
export { VIEW, REVIEW, CLEAR, SEARCH }
